

















































































/** 创意工具生成视频在平台渲染的逻辑 */
import { computed, defineComponent, toRefs } from '@vue/composition-api';
import { VideoTaskStatus } from '@tt4b/ttam-enums';
import { useVideoExtStatus, useTasks } from '@tt4b/ttam-hooks';

import TtamMaterialCover from '@/components/common/material-cover/index.vue';

/** 最大重试次数 */
const MAX_RETRY_COUNT = 3;
const {
  RENDERING,
  SUBMITTED,
  CANCELLED,
  WAITING_FOR_DEPENDENCY,
  PAUSED,
  RESUMED,
  RENDER_ERROR,
  TIMEOUT,
  RENDER_DONE_NOT_CREATED,
} = VideoTaskStatus;
const name = 'ttam-creative-async-video-render';

export default defineComponent({
  name,

  components: {
    TtamMaterialCover,
  },
  props: {
    index: {
      type: Number,
      default: -1,
    },
    taskId: {
      type: String,
      default: '',
    },
    // 只展示进度条
    onlyProgress: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, ctx) {
    const { taskId } = toRefs(props);

    const { retry, clear } = useTasks();
    const { getVideoExtInfoByUuid, setExtVideoRetryCount } = useVideoExtStatus();

    /** 渲染进度信息 */
    const videoExtInfo = computed(() => getVideoExtInfoByUuid(taskId.value));
    const progress = computed(() => videoExtInfo.value.process || 0);
    const coverUrl = computed(() => videoExtInfo.value.coverUrl || '');

    /** 是否正在渲染中 */
    const isInProcess = computed(() => {
      if (videoExtInfo.value?.status === undefined) {
        return true;
      }

      return [RENDERING, SUBMITTED, RENDER_DONE_NOT_CREATED].includes(videoExtInfo.value.status);
    });

    /** 是否有渲染异常 */
    const isException = computed(() => {
      if (videoExtInfo.value?.status === undefined) {
        return false;
      }

      return [CANCELLED, WAITING_FOR_DEPENDENCY, PAUSED, RESUMED, RENDER_ERROR, TIMEOUT].includes(
        videoExtInfo.value.status,
      );
    });

    /** 报错重置 */
    const isWarning = computed(() => {
      if (!isException.value) {
        return false;
      }

      return (videoExtInfo.value?.retryCount || 0) < MAX_RETRY_COUNT;
    });

    const isError = computed(() => {
      if (!isException.value) {
        return false;
      }
      if ((videoExtInfo.value?.retryCount || 0) >= MAX_RETRY_COUNT) {
        return true;
      }

      return false;
    });

    /** 重试渲染 */
    const onRetry = () => {
      if (taskId.value) {
        retry(taskId.value);
        setExtVideoRetryCount(taskId.value);
      }
    };

    /** 删除素材 */
    const onDelete = () => {
      clear(videoExtInfo.value.taskId);
      ctx.emit('delete', taskId.value);
    };

    return {
      isError,
      isWarning,
      isInProcess,
      isException,
      name,
      coverUrl,
      progress,
      videoExtInfo,
      onRetry,
      onDelete,
    };
  },
});
